import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import AuthService from "../../services/AuthService";
import {
  otpFail,
  otpSuccess,
  resendOTPFail,
  resendOTPSuccess,
  resetPasswordFail,
  resetPasswordSuccess,
  sendResetPasswordInstructionsFail,
  sendResetPasswordInstructionsSuccess,
  sessionFail,
  sessionSuccess,
  verifyOTPFail,
  verifyOTPSuccess,
} from "../slices/authSlice";

function* login(data) {
  try {
    const ajax = yield call(AuthService.login, data.payload);
    if (ajax.status === 200) {
      yield put(sessionSuccess(ajax.data));
    } else {
      yield put(
        sessionFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sessionFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* sendResetInstructions(data) {
  try {
    const ajax = yield call(AuthService.forgotPassword, data.payload);
    if (ajax.status === 200) {
      yield put(sendResetPasswordInstructionsSuccess(ajax.data));
    } else {
      yield put(
        sendResetPasswordInstructionsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sendResetPasswordInstructionsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* resetPassword(data) {
  try {
    const ajax = yield call(AuthService.resetPassword, data.payload);
    if (ajax.status === 200) {
      yield put(resetPasswordSuccess(ajax.data));
    } else {
      yield put(
        resetPasswordFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      resetPasswordFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* refereshToken(data) {
  try {
    const ajax = yield call(AuthService.refreshToken, data.payload);
    if (ajax.status === 200) {
      yield put(sessionSuccess(ajax.data));
    } else {
      yield put(
        sessionFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sessionFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* requestOTP(data) {
  try {
    const ajax = yield call(AuthService.requestOtp, data.payload);
    if (ajax.status === 200) {
      yield put(otpSuccess(ajax.data));
    } else {
      yield put(
        otpFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      otpFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* resendOtp(data) {
  try {
    const ajax = yield call(AuthService.resendOtp, data.payload);
    if (ajax.status === 200) {
      yield put(resendOTPSuccess(ajax.data));
    } else {
      yield put(
        resendOTPFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      resendOTPFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* verifyOtp(data) {
  try {
    const ajax = yield call(AuthService.verifyOtp, data.payload);
    if (ajax.status === 200) {
      yield put(verifyOTPSuccess(ajax.data));
    } else {
      yield put(
        verifyOTPFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      verifyOTPFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* logout() {
  yield call(AuthService.logout);
}

export default function* authSaga() {
  yield all([
    takeLatest("auth/sessionRequest", login),
    takeLatest(
      "auth/sendResetPasswordInstructionsRequest",
      sendResetInstructions
    ),
    takeLatest("auth/resetPasswordRequest", resetPassword),
    takeLatest("auth/logout", logout),
    takeLatest("auth/refreshTokenRequest", refereshToken),
    takeLatest("auth/otpRequest", requestOTP),
    takeLatest("auth/resendOTPRequest", resendOtp),
    takeLatest("auth/verifyOTPRequest", verifyOtp),
  ]);
}
